import { useEffect, useState } from "react";
import classes from "./HomeSkeleton.module.css";

const HomeSkeleton = () => {
  const [itemsCount, setItemsCount] = useState(4);

  useEffect(() => {
    const updateCount = () => {
      const width = window.innerWidth;

      if (width <= 600) {
        setItemsCount(1);
      } else if (width <= 1024) {
        setItemsCount(2);
      } else if (width <= 1400) {
        setItemsCount(3);
      } else {
        setItemsCount(4);
      }
    };

    updateCount(); // initial
    window.addEventListener("resize", updateCount);

    return () => window.removeEventListener("resize", updateCount);
  }, []);

  return (
    <div className={classes.homeSkeleton}>
      <div className={`${classes.skBanner} ${classes.skeleton}`} />

      <div className={classes.skHeader}>
        <div className={`${classes.skLogo} ${classes.skeleton}`} />
        <div className={`${classes.skSearch} ${classes.skeleton}`} />
        <div className={classes.skIcons}>
          <div className={`${classes.skCircle} ${classes.skeleton}`} />
          <div className={`${classes.skCircle} ${classes.skeleton}`} />
        </div>
      </div>

      <div className={classes.skHero}>
        <div className={classes.skHeroLeft}>
          <div className={`${classes.skBadge} ${classes.skeleton}`} />

          <div className={classes.skTitleBlock}>
            <div
              className={`${classes.skLine} ${classes.skLineLg} ${classes.skeleton}`}
            />
            <div
              className={`${classes.skLine} ${classes.skLineLg} ${classes.skeleton}`}
            />
            <div
              className={`${classes.skLine} ${classes.skLineMd} ${classes.skeleton}`}
            />
            <div
              className={`${classes.skLine} ${classes.skLineSm} ${classes.skeleton}`}
            />
          </div>

          <div className={`${classes.skCta} ${classes.skeleton}`} />
        </div>

        <div className={classes.skHeroRight}>
          <div className={`${classes.skMedia} ${classes.skeleton}`} />
        </div>
      </div>

      <div className={`${classes.skSectionTitle} ${classes.skeleton}`} />

      <div className={classes.skList}>
        {Array.from({ length: itemsCount }).map((_, i) => (
          <div key={i} className={classes.skListItem}>
            <div
              className={`${classes.skLine} ${classes.skLineLg} ${classes.skeleton}`}
            />
            <div
              className={`${classes.skLine} ${classes.skLineSm} ${classes.skeleton}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeSkeleton;
